import * as Sentry from "@sentry/react";

/*
  Select GTM ID based on Environment
*/
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

/**
 *
 * Enable Sentry for error reporting
 *
 */
if (SENTRY_DSN && import.meta.env.VITE_ENV !== "development") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [],
    environment: import.meta.env.VITE_ENV,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
    sendDefaultPii: true,
  });
}
